import { FormFieldDatePicker } from 'Components/FormField/FormFieldDatePicker/FormFieldDatePicker';

interface QuestionDateProps {
    formFieldId: string;
    onAnswerChanged: (date: Date) => void;

    disabled?: boolean;
    selectedDate?: Date;
}

export const QuestionDate = (props: QuestionDateProps) => {
    return <FormFieldDatePicker selected={props.selectedDate} handleChange={props.onAnswerChanged} dateFormat="MM/DD/YYYY" formFieldId={props.formFieldId} formFieldLabel="Answer" placeholder={'MM/DD/YYYY'} disabled={props.disabled} />;
};
